<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card title="Quests habilitadas">
      <div slot="no-body" class="mt-4">
        <vs-table ref="table" pagination :max-items="itemsPerPage" :data="quests">
          <template slot="thead">
            <vs-th sort-key="name">Nome</vs-th>
            <vs-th sort-key="description">Descrição</vs-th>
            <vs-th sort-key="end_date">Prazo</vs-th>
            <vs-th sort-key="end_date">Estado</vs-th>
            <vs-th>Ações</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium">{{ tr.quest.name }}</p>
              </vs-td>
              <vs-td>
                <p class="product-category">{{ tr.quest.description }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ formatDate(tr.end_date) }}</p>
              </vs-td>

              <vs-td>
                <vs-chip
                  :color="getStatus(tr.start_date, tr.end_date).color"
                  class="product-order-status"
                >{{ getStatus(tr.start_date, tr.end_date).status }}</vs-chip>
              </vs-td>
              <vs-td>
                <vs-button
                  v-if="getStatus(tr.start_date, tr.end_date).status == 'Disponível'"
                  :to="`/quest/${tr.quest.id}`"
                  color="primary"
                  type="gradient"
                >Abrir</vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <vx-card title="Quests em progresso ou finalizadas" class="mt-5">
      <div slot="no-body" class="mt-4">
        <vs-table ref="table" pagination :max-items="itemsPerPage" :data="questSubmissions" >
          <template slot="thead">
            <vs-th sort-key="name">Nome</vs-th>
            <vs-th sort-key="description">Descrição</vs-th>
            <vs-th sort-key="end_date">Prazo</vs-th>
            <vs-th sort-key="end_date">Estado</vs-th>
            <vs-th>Ações</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium">{{ tr.quest.name }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.quest.description }}</p>
              </vs-td>
              <vs-td>
                <p v-if="tr.access">{{ formatDate(tr.access.end_date) }}</p>
              </vs-td>
              <vs-td>
                <vs-chip
                  :color="translateStatus(tr.status).color"
                  class="product-order-status"
                >{{ translateStatus(tr.status).text }}</vs-chip>
              </vs-td>
              <vs-td>
                <vs-button
                  :to="`/quest/${tr.quest.id}`"
                  color="primary"
                  type="gradient"
                >Abrir</vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import {
  getQuests
} from "../../_services/quest.service.js";

import {
  getQuestSubmissions
} from "../../_services/questSubmission.service.js";

export default {
  components: {},
  data() {
    return {
      selected: [],
      quests: [],
      questSubmissions: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    ...mapState({
      account: state => state.account
    })
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getStatus(start_date, end_date) {
      let isAvailable = moment().isBetween(
        moment(start_date),
        moment(end_date),
        null, '[]'
      );
      if (isAvailable) {
        return { status: "Disponível", color: "success" };
      } else {
        return { status: "Indisponível", color: "danger" };
      }
    },
    translateStatus(status) {
      let statuses = {
          approved: { text: 'Aprovado', color: 'success' },
          waiting: { text: 'Aguardando', color: 'warning' },
          reproved: { text: 'Recusado', color: 'danger' },
          in_progress: { text: 'Em progresso', color: 'blue' },
      }
      return statuses[status]
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    async fetchQuests() {
      let fetchedQuests = await getQuests({
        student_id: this.account.user.student.id
      });
      
      let questSubmissions = await this.fetchQuestSubmissions();

      let questsWithoutSubmission = fetchedQuests.filter(ele => {
        const exists = questSubmissions.find(el => {
          return el.quest.id == ele.quest.id;
        });
        return exists ? false : true;
      });

      for (let questSubmission of questSubmissions) {
        let access = fetchedQuests.find(el => {
          return el.quest_id == questSubmission.quest_id;
        });
        if (access) {
          questSubmission.access = access
          delete questSubmission.access.quest
        }
      }

      this.quests = questsWithoutSubmission;
      this.questSubmissions = questSubmissions;
    },
    async fetchQuestSubmissions() {
      return await getQuestSubmissions({
        student_id: this.account.user.student.id
      });
    }
  },
  created() {
    this.fetchQuests();
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
